import React, {Fragment} from 'react'
import {Trans, translate} from 'react-i18next'
import {withTheme} from 'styled-components'
import {compose} from 'utils/reactUtils'
import Link from 'components/Link'
import {getFAQLink} from 'utils/getFAQLink'
import {SubtitleView, SubtitleFAQView} from './SubtitleStyles'
import {getAboutLink} from 'utils/languageUtils'
import {GoogleAnalyticsService} from 'services'
import {getConfigValue} from 'theme'

const SubtitleWithAboutLink = ({styles, theme, loginCase, i18n}) => {
  const faqURL = getConfigValue('subtitleWithFAQLanding', {loginCase}) ? getFAQLink(theme.brand.name) : ''
  const viewStyles = faqURL ? {margin: '4px 0 0'} : styles

  let subtitleKey = 'subtitle-with-about-link'

  if (i18n.exists(`subtitle-with-about-link-${loginCase}`)) {
    subtitleKey = `subtitle-with-about-link-${loginCase}`
  }

  return (
    <Fragment>
      <SubtitleView styles={viewStyles}>
        <Trans i18nKey={subtitleKey}>
          We are partners of the central Swiss media login OneLog.
          <Link
            fontSize="inherit"
            onClick={() => GoogleAnalyticsService.trackMoreInfoLink()}
            to={getAboutLink()}
            target="_blank"
            external>
            More info
          </Link>
        </Trans>
      </SubtitleView>
      {faqURL && (
        <SubtitleFAQView>
          <Trans i18nKey="subtitle-with-faq-link">
            text
            <Link fontSize="inherit" to={faqURL} target="_blank" rel="nofollow" external>
              FAQ Page
            </Link>
          </Trans>
        </SubtitleFAQView>
      )}
    </Fragment>
  )
}

export default compose(translate(), withTheme)(SubtitleWithAboutLink)
